import React, { MutableRefObject, useContext } from 'react'

import styled from 'styled-components'

import { MetamaskStyledSVG } from './WalletLogos'

const _WalletConnectionModal = styled.div`
  text-align: center;
  font-size: 1.5em;
  overflow: scroll;
  align-self: center;
  color: ${({ theme }) => theme.swapCurrencySelectorPanelTextColor};
  background-color: ${({ theme }) =>
    theme.swapCurrencySelectorPanelBackgroundColor};
  border-radius: 0.25em;
  padding: 1.5em;
  width: 400px;
  //    border: 4px solid swaapGreen0;

  /* Tablets */
  @media (max-width: 1400px) {
    width: 400px;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    width: 60%;
  }
`

const _WalletConnectionModalWrapper = styled.div`
  font-size: 0.75em;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
`

//const MetamaskLink = styled.a`
//	text-decoration: none;
//	color: inherited
//`

const WalletModalTitle = styled.div`
  font-size: 0.6em;
  font-weight: bold;
  padding-bottom: 1.75em;
  text-align: left;
  color: ${({ theme }) => theme.walletModalTitleTextColor};
  //    color: ${({ theme }) => '#1DDD94'};
`

const WalletChoice = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding: 0.25em;
  padding-left: 0.5em;
  border-radius: 0.4em;
  //	width:20vw;
  box-shadow: ${({ theme }) => theme.walletSelectionShadow};
  color: ${({ theme }) => theme.walletSelectionTextColor};
  background-color: ${({ theme }) => theme.walletSelectionBackgroundColor};
  width: 100%;
  font-size: 1.75em;
  border: none;
  text-decoration: none;
  &:hover {
    cursor: pointer;
    opacity: 0.95;
    background-color: ${({ theme }) =>
      theme.walletSelectionBackgroundColorHover};
  }
  &:active {
    box-shadow: ${({ theme }) => 'inset ' + theme.walletSelectionShadow};
  }
`

const WalletChoiceName = styled.div`
  font-size: 0.75em;
  font-weight: normal;
  align-self: center;
  padding-left: 0.75em;
`
interface ModalProps {
  handleRef: MutableRefObject<any>
  handleAllowWeb3: () => void
}
function WalletConnectionModal(props: ModalProps) {
  return (
    <_WalletConnectionModal ref={props.handleRef}>
      <WalletModalTitle>Connect to a wallet</WalletModalTitle>
      <WalletChoice onClick={props.handleAllowWeb3}>
        <MetamaskStyledSVG />
        <WalletChoiceName>MetaMask</WalletChoiceName>
      </WalletChoice>
    </_WalletConnectionModal>
  )
}

function WalletConnectionModalWrapper(props: ModalProps) {
  return (
    <>
      {
        <_WalletConnectionModalWrapper>
          <WalletConnectionModal
            handleRef={props.handleRef}
            handleAllowWeb3={props.handleAllowWeb3}
          />
        </_WalletConnectionModalWrapper>
      }
    </>
  )
}

export default WalletConnectionModalWrapper
